import { forwardRef, useImperativeHandle, useState } from 'react';
import Turnstile from 'react-turnstile';
import { toast } from 'react-hot-toast';

function TurnstileCaptchaInner({
  onVerify,
  onLoad,
  onExpire,
  onError,
  onUnsupported,
  sitekey,
  className,
  theme = 'light',
}, ref) {
  const [captchaKey, setCaptchaKey] = useState(0);

  useImperativeHandle(ref, () => ({
    reset: () => setCaptchaKey(prev => prev + 1),
  }));

  const handleError = () => {
    if (onError) onError();
    else toast.error('Failed to load captcha. Please refresh.');
  };

  const handleUnsupported = () => {
    if (onUnsupported) onUnsupported();
    else toast.error('Captcha is unsupported in this browser.');
  };

  const handleExpire = () => {
    if (onExpire) onExpire();
  };

  const handleLoad = () => {
    if (onLoad) onLoad();
  };

  const handleVerify = (token) => {
    if (onVerify) onVerify(token);
  };

  const SITE_KEY = sitekey || process.env.REACT_APP_TURNSTILE_SITE_KEY;

  return (
    <div className={className || 'recaptcha-wrapper'}>
      <Turnstile
        sitekey={SITE_KEY}
        onVerify={handleVerify}
        onExpire={handleExpire}
        onLoad={handleLoad}
        onError={handleError}
        onUnsupported={handleUnsupported}
        key={captchaKey}
        theme={theme}
      />
    </div>
  );
}

const TurnstileCaptcha = forwardRef(TurnstileCaptchaInner);
export default TurnstileCaptcha;

